// Stored size of editor content: UTF-8 bytes of the serialized value (Lexical JSON or HTML).
export function getContentSize(content) {
    return new TextEncoder().encode(content || '').length;
}

// Visible-text length of editor content — counts what the user sees, not the serialized value.
// Lexical JSON: sum of text-node text. Legacy HTML: stripped to textContent (markup/entities don't count).
// No Lexical imports, so it's safe for the globally-bundled validators (the editor itself is lazy-loaded).
export function getTextLength(content) {
    if (!content) return 0;

    let json;
    try {
        json = JSON.parse(content);
    }
    catch {
        // DOMParser builds an inert document (no script execution, no resource loads), so this is safe on stored HTML.
        return (new DOMParser().parseFromString(content, 'text/html').body.textContent || '').trim().length;
    }

    let total = 0;
    const walk = (node) => {
        if (!node) return;
        if (typeof node.text === 'string') total += node.text.length;
        if (Array.isArray(node.children)) node.children.forEach(walk);
    };
    walk(json.root);
    return total;
}
